export default __webpack_public_path__ + "static/media/myflix.b4549da0.png";